export const siteSettings = {
  name: "The Iron Markets",
  link: "https://theironmarkets.com",
  email: "support@theironmarkets.com",
  appLink: "https://app.theironmarkets.com",
};
